import { Link } from "react-router-dom";
import { Film } from "lucide-react";

const topicLinks = [
  { slug: "studios-production", label: "Studios & Production" },
  { slug: "theaters-where-to-watch", label: "Theaters & Where to Watch" },
  { slug: "film-schools-education", label: "Film Schools & Education" },
  { slug: "halls-of-fame-history", label: "Halls of Fame & History" },
  { slug: "business-box-office-technology", label: "Business & Technology" },
  { slug: "genres-languages", label: "Genres & Languages" },
  { slug: "documentary-cinema", label: "Documentary Cinema" },
  { slug: "animation-worldwide", label: "Animation Worldwide" },
  { slug: "women-in-film", label: "Women in Film" },
  { slug: "restoration-preservation", label: "Restoration & Preservation" },
  { slug: "short-films-student-cinema", label: "Shorts & Student Cinema" },
  { slug: "sound-music-in-cinema", label: "Sound & Music in Cinema" },
];

export const Footer = () => (
  <footer className="bg-[#171210] text-[#d6cebf] mt-20">
    <div className="film-strip" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-3">
          <span className="w-8 h-8 rounded-full bg-[#7d1a1a] flex items-center justify-center">
            <Film className="w-4 h-4 text-[#f6f1e7]" />
          </span>
          <span className="font-display font-bold text-xl text-[#f6f1e7]">MoviePulse<span className="text-[#c94b4b]">.pro</span></span>
        </div>
        <p className="text-sm leading-relaxed max-w-md text-[#a99e8d]">
          A global cinema discovery and cultural-history network — every country, region and city gets a living cinema home. Films, people, theaters, festivals, history and community, with respect for creators and rights.
        </p>
        <p className="font-script text-2xl text-[#b06810] mt-4">A more cinematic world.</p>
      </div>
      <div>
        <h4 className="font-mono-label text-xs tracking-[0.25em] uppercase text-[#c94b4b] mb-4">Discover</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/explore" className="hover:text-[#f6f1e7] transition-colors">Explore Movies</Link></li>
          <li><Link to="/countries" className="hover:text-[#f6f1e7] transition-colors">Countries & Industries</Link></li>
          <li><Link to="/cities" className="hover:text-[#f6f1e7] transition-colors">Film Cities</Link></li>
          <li><Link to="/people" className="hover:text-[#f6f1e7] transition-colors">People & Careers</Link></li>
          <li><Link to="/festivals" className="hover:text-[#f6f1e7] transition-colors">Festivals & Awards</Link></li>
          <li><Link to="/news" className="hover:text-[#f6f1e7] transition-colors">News & Editorial</Link></li>
          <li><Link to="/community" className="hover:text-[#f6f1e7] transition-colors">Community Forums</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-mono-label text-xs tracking-[0.25em] uppercase text-[#c94b4b] mb-4">Topics</h4>
        <ul className="space-y-2 text-sm">
          {topicLinks.map((t) => (
            <li key={t.slug}>
              <Link to={`/topics/${t.slug}`} data-testid={`footer-topic-${t.slug}`} className="hover:text-[#f6f1e7] transition-colors">
                {t.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-[#2a2019] py-5 text-center">
      <p className="font-mono-label text-[10px] tracking-[0.3em] uppercase text-[#6b5d51]">
        Different Places. A Brighter Picture. — © 2026 MoviePulse.pro
      </p>
    </div>
  </footer>
);
